var convert = require('./convert'),
    func = convert('map', require('../map'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/fp/map.js
 ** module id = 548
 ** module chunks = 0
 **/